import { render, staticRenderFns } from "./ReviewsCarousel.vue?vue&type=template&id=0041b961&scoped=true&lang=pug"
import script from "./ReviewsCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReviewsCarousel.vue?vue&type=style&index=0&id=0041b961&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0041b961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0041b961')) {
      api.createRecord('0041b961', component.options)
    } else {
      api.reload('0041b961', component.options)
    }
    module.hot.accept("./ReviewsCarousel.vue?vue&type=template&id=0041b961&scoped=true&lang=pug", function () {
      api.rerender('0041b961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/ReviewsCarousel.vue"
export default component.exports